import script from "./PotentialCustomers.vue?vue&type=script&setup=true&lang=js"
export * from "./PotentialCustomers.vue?vue&type=script&setup=true&lang=js"

import "./PotentialCustomers.vue?vue&type=style&index=0&id=7ea9d9b3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ea9d9b3"]])

export default __exports__